module.exports = __webpack_public_path__ + "static/media/DefaultBanner.3eb21636.jpg";